__turbopack_context__.v({
  "checkbox-group": "index-module-scss-module__SJex5q__checkbox-group",
  "label": "index-module-scss-module__SJex5q__label",
});
